import { AuthenticatedUser } from "@climatepartner/app-shell/auth";
import { CpServices } from "@climatepartner/utils";
import { SolutionType } from "@service/shared/enums";
import { createContext } from "react";

export type CfcUser = AuthenticatedUser & {
  customerId: string | null;
  isAuthenticated: boolean;
  isEmissionFactorAdmin: boolean;
  services: CpServices;
  allowedSolutions: SolutionType[];
  isCsrdEnabled: boolean;
  isTrialUser: boolean;
};

export type UserContextType = {
  user: CfcUser | null;
  hasAccessToOrganization: (organizationId: string) => boolean;
  logout: (postLogoutRedirectUri: string) => void;
  hasPermission: (permission: string) => boolean;
};

const initialUserContextState = {
  user: null,
  logout: (): void => {
    // not implemented
  },
  hasAccessToOrganization: (): boolean => false,
  hasPermission: (): boolean => false,
};

export const UserContext = createContext<UserContextType>(initialUserContextState);
